let audioCtx: AudioContext | null = null
let oscillator: OscillatorNode | null = null

/*
    Chrome freezes background-tab JS after ~5 min, blocking LastLook popouts.
    An inaudible 1 Hz oscillator at near-zero gain keeps the tab alive.
    The Chrome speaker icon is intentional — signals active orders to the trader.
*/
export const startTabKeepAlive = (): void => {
  if (audioCtx) return
  audioCtx = new AudioContext()
  oscillator = audioCtx.createOscillator()
  oscillator.frequency.value = 1
  const gain = audioCtx.createGain()
  gain.gain.value = 0.01
  oscillator.connect(gain)
  gain.connect(audioCtx.destination)
  oscillator.start()
  if (audioCtx.state === 'suspended') {
    void audioCtx.resume()
  }
}

export const stopTabKeepAlive = (): void => {
  if (oscillator) {
    oscillator.stop()
    oscillator.disconnect()
    oscillator = null
  }
  if (audioCtx) {
    void audioCtx.close()
    audioCtx = null
  }
}

export const _isActiveForTest = (): boolean => audioCtx !== null
